import { Directive, ElementRef, HostBinding, HostListener } from '@angular/core';
import { DropdownDirective } from './dropdown.directive';

@Directive({
    selector: '[rsDropdownToggle]'
})
export class DropdownToggleDirective {
    @HostBinding('class.dropdown-toggle') classes = true;
    @HostBinding('attr.aria-haspopup') hasPopup = true;
    @HostBinding('attr.aria-expanded') expanded = 'dropdown.isOpen';
    @HostListener('click') onClick() {
        this.dropdown.toggle();
    }

    constructor(
        public dropdown: DropdownDirective,
        elementRef: ElementRef
    ) {
        dropdown.toggleElement = elementRef.nativeElement;
    }
}
